function CamisetasPagination({ currentPage, totalPages, onPageChange }) {
    if (totalPages <= 1) {
        return null;
    }

    const MAX_VISIBLE_PAGES = 5;
    const allPages = Array.from({ length: totalPages }, (_, index) => index + 1);

    const visiblePages = (() => {
        if (allPages.length <= MAX_VISIBLE_PAGES) {
            return allPages;
        }

        const halfWindow = Math.floor(MAX_VISIBLE_PAGES / 2);
        let startIndex = Math.max(0, currentPage - 1 - halfWindow);
        let endIndex = startIndex + MAX_VISIBLE_PAGES;

        if (endIndex > allPages.length) {
            endIndex = allPages.length;
            startIndex = endIndex - MAX_VISIBLE_PAGES;
        }

        return allPages.slice(startIndex, endIndex);
    })();

    return (
        <div className="mt-5 sm:mt-6 pt-5 sm:pt-6 border-t border-white/10 space-y-2 sm:space-y-3">
            <p className="text-center text-xs sm:text-sm text-slate-400 font-medium">
                Página {currentPage} de {totalPages}
            </p>

            <div className="overflow-x-auto scrollbar-hide">
                <div className="flex items-center justify-center sm:justify-end gap-1 min-w-max px-1">
                    <button
                        type="button"
                        onClick={() => onPageChange(Math.max(1, currentPage - 1))}
                        disabled={currentPage <= 1}
                        className="h-9 px-3 rounded-lg bg-[#102216] border border-white/10 text-slate-300 disabled:opacity-40 disabled:cursor-not-allowed hover:border-green-500"
                    >
                        ←
                    </button>

                    {visiblePages.map((page) => (
                        <button
                            key={page}
                            type="button"
                            onClick={() => onPageChange(page)}
                            className={`h-9 min-w-9 px-3 rounded-lg text-sm font-bold border transition-colors ${page === currentPage
                                ? "bg-green-500 text-[#062a1a] border-green-500"
                                : "bg-[#102216] text-slate-200 border-white/10 hover:border-green-500"
                                }`}
                        >
                            {page}
                        </button>
                    ))}

                    <button
                        type="button"
                        onClick={() => onPageChange(Math.min(totalPages, currentPage + 1))}
                        disabled={currentPage >= totalPages}
                        className="h-9 px-3 rounded-lg bg-[#102216] border border-white/10 text-slate-300 disabled:opacity-40 disabled:cursor-not-allowed hover:border-green-500"
                    >
                        →
                    </button>
                </div>
            </div>
        </div>
    );
}

export default CamisetasPagination;
